// this and other enums whcih may be stored in database need to be coverted to maps as inserting new values will invalidate data

export enum Units {
  Unknown,
  Degrees,
  Degrees_C,
  Percent,
  hPA,
  Volts,
  mVolts,
  HMS,
  Meters,
  Millimeters,
  Km,
  Rolls,
  Moves,
  Count,
  RH,
  ALS,
  Days,
  Hours,
  Minutes,
  Seconds,
  Milliseconds,

}
